import { glbGetLocalStorage } from '../../../Helpers/GlobalFunctions';
import { ReactSession } from 'react-client-session';
export default function ChatLogin(props) {
    let lsRefreshToken = glbGetLocalStorage("refreshtoken");
    let lscurrenthref = ReactSession.get("currenthref");
    let lscurdomain = ReactSession.get("currenttpdomain");
    let lsloginid = glbGetLocalStorage("loginid");
    let loparams = btoa(JSON.stringify({ refreshtoken: lsRefreshToken, logid: lsloginid, dn: lscurdomain, href: lscurrenthref }));
    if (lscurdomain === "dev.oreapps.com") { 
        window.open("https://devai.oreapps.com?q=" + loparams, "_self");
    }
    else {
        window.open("https://chat.sterloapp.com?q=" + loparams, "_self");
    }
    // window.open(" https://localhost:44492?q=" + loparams, "_self");
    return (
        <>
        </>
    );
}

